<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
            <vue-headful :title="jsa.jsa_name + ' [JSA] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/jsa`">
                            <i class="fa fa-files-o"></i> JSA
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        {{ jsa.jsa_name }}
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-lg-8">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>JSA: {{ jsa.jsa_name }}</strong>

                            <div class="pull-right">
                                <router-link :to="`/jsa/print/${jsa.jsa_id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-file-pdf-o"></i> PDF
                                </router-link>
                                <template v-if="jsa.status_context == 'InProgress'">
                                    <router-link :to="`/jsa/edit/${jsa.jsa_id}`" class="btn btn-sm btn-light">
                                        <i class="fa fa-edit"></i> Resume Editing
                                    </router-link>
                                </template>
                                <template v-if="jsa.status_context == 'Closed'">
                                    <b-button variant="light" size="sm" v-on:click="cloneJSA()"><i class="fa fa-copy"></i> Clone</b-button>
                                </template>
                                <router-link :to="`/jsa/delete/${jsa.jsa_id}`" class="btn btn-sm btn-light" v-if="$root.hasPermission('jsa.manage') || (jsa.UserId == $store.state.user.user_id && $root.hasPermission('jsa.create'))">
                                    <span class="text-danger"><i class="fa fa-trash"></i> Delete</span>
                                </router-link>
                            </div>

                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col text-muted">Status</div>
                                <div class="col-md-8">{{ jsa.status_name }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">JSA Name</div>
                                <div class="col-md-8">{{ jsa.jsa_name }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">JSA Date</div>
                                <div class="col-md-8">{{ jsa.jsa_date_formatted }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">User</div>
                                <div class="col-md-8"><user-name :user="jsa" /></div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Jobsite</div>
                                <div class="col-md-8">
                                    <router-link :to="`/jobsites/view/${jsa.JobsiteId}`">
                                        {{ jsa.JobsiteNumber }} - {{ jsa.JobsiteName }}
                                    </router-link>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Contractor</div>
                                <div class="col-md-8">{{ jsa.jsa_contractor }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Total # of Steps</div>
                                <div class="col-md-8">{{ totalSteps }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Total # of Hazards</div>
                                <div class="col-md-8">{{ totalHazards }}</div>
                            </div>

                            <hr/>

                            <div class="row mb-2">
                                <div class="col text-muted">Building/Area:</div>
                                <div class="col-md-8">{{ jsa.jsa_building_area }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Description of Work:</div>
                                <div class="col-md-8">{{ jsa.jsa_description }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Standard PPE:</div>
                                <div class="col-md-8">{{ jsa.jsa_safety_equipment }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Specialized PPE:</div>
                                <div class="col-md-8">{{ jsa.jsa_specialized_equipment }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Monitoring Activities:</div>
                                <div class="col-md-8">{{ jsa.jsa_monitoring_act }}</div>
                            </div>

                            <hr/>

                            <file-list :files="[currentFile]" v-if="currentFile" />
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="card mb-3">
                        <div class="card-header">
                            <i class="fa fa-files-o"></i> All Files
                        </div>
                        <div class="card-body">
                            <file-list :files="files" />

                            <template v-if="$root.hasPermission('jsa.manage') || (jsa.UserId == $store.state.user.user_id && $root.hasPermission('jsa.create'))">
                                <hr/>
                                <b-form-file
                                  v-model="new_file"
                                  placeholder="Choose a file or drop it here..."
                                  drop-placeholder="Drop file here..."
                                  :disabled="uploading"
                                ></b-form-file>
                                <div v-if="uploading" class="mt-2">
                                    <i class="fa fa-spin fa-spinner"></i> Uploading File
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4 d-sm-flex d-none">
                <b-nav-item :active="curTab === 'steps'" @click="curTab = 'steps'">
                    Steps & Hazards
                </b-nav-item>
                <b-nav-item :active="curTab === 'employees'" @click="curTab = 'employees'">
                    <i class="fa fa-group"></i> Employee <template v-if="empCount != null">({{ empCount }})</template>

                    <button class="btn btn-xs btn-success" v-on:click="modal_open = true;" style="font-size: 0.7rem;"><i class="fa fa-plus"></i></button>
                </b-nav-item>
            </ul>

            <div class="mb-2 mb-lg-0 d-sm-none d-block">
                <b-dropdown :html="getTabTitle" variant="default" class="bg-white">
                    <b-dropdown-item :active="curTab === 'steps'" @click="curTab = 'steps'">
                        Steps & Hazards
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'employees'" @click="curTab = 'employees'">
                        <i class="fa fa-group"></i> Employees <template v-if="empCount != null">({{ empCount }})</template>
                    </b-dropdown-item>
                </b-dropdown>

                <button type="button" v-show="curTab === 'employees'" class="btn btn-success" v-on:click="modal_open = true;">
                    <i class="fa fa-plus"></i> Employee
                </button>
            </div>

            <div class="card">
                <div class="card-body">
                    <div v-show="curTab === 'steps'">
                        <ol>
                           <li v-for="step in jsa.jsa_steps" class="mb-2">
                                {{ step.step_label }}
                                <ul>
                                   <li v-for="hazard in step.hazards" class="mb-1">
                                        <span :class="`badge badge-${getRacLevelColor(hazard.rac_level)}`">{{ hazard.rac_level }}</span>
                                        {{ hazard.hazard }}
                                        |
                                        <span class="text-primary" title="Standard Controls">
                                            <template v-for="(control, index) in hazard.controls"><template v-if="index > 0">, </template>{{ control }}</template>
                                            <template v-if="hazard.other_controls">{{ hazard.other_controls }}</template>
                                        </span>
                                   </li>
                                </ul>
                           </li>
                        </ol>
                    </div>
                    <div v-show="curTab === 'employees'">
                        <jsa-employee-list ref="jsaEmpList" :jsa_id="jsa.jsa_id" @jsaEmployeeListCount="function(count){ empCount = count; }" />
                    </div>
                </div>
            </div>
        </div>

        <b-modal
            v-model="modal_open"
            title="Attach Employees to this JSA"
            size="lg"
            ok-title="Attach Employees"
            ok-variant="success"
            no-fade
            @hide="handleHide"
            @hidden="handleHidden"
            @ok="handleOk"
            ref="hazardModal"
            :no-close-on-backdrop="true"
            scrollable>

            <div style="min-height: 300px;">
                <div class="row">
                    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right">
                        Select Employee(s)
                    </label>
                    <div class="col-lg-6 col-md-6 col-sm-8">
                        <employee-select ref="jsaEmpSelector" @vselected="jsaEmpSelect"></employee-select>

                        <div class="mt-2">
                            <ol class="list-unstyled">
                                <li v-for="emp in new_employees">
                                    <button class="btn btn-xs btn-link"><span class="text-danger"><i class="fa fa-trash"></i></span></button>
                                    {{ emp.FirstName }} {{ emp.LastName }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

        </b-modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                uploading: false,
                modal_open: false,
                curTab: 'steps',
                jsa_id: this.$route.params.id,
                jsa: {},
                files: [],
                new_employees: [],
                new_file: null,
                empCount: null,
                errors: {},
            }
        },

        watch: {
            new_file(newVal, oldVal){
                //Check for null
                if(newVal == null)
                {
                    return;
                }

                //Save it
                this.saveNewFile();
            },
        },

        computed: {

            totalSteps(){
                //Send it
                return this.jsa.jsa_steps.length;
            },

            totalHazards(){
                //Start it
                var t = 0;

                //Loop and count
                for (var i = this.jsa.jsa_steps.length - 1; i >= 0; i--)
                {
                    t += this.jsa.jsa_steps[i].hazards.length;
                }

                //Send it
                return t;
            },

            currentFile(){
                var file = null;

                for (var i = this.files.length - 1; i >= 0; i--)
                {
                    if(this.jsa.file_id == this.files[i].id)
                    {
                        file = this.files[i];
                    }
                }

                //Send it
                return file;
            },

            getTabTitle(){
                //Setup
                var title = '';
                var icon = 'bars';

                //Switch
                switch(this.curTab)
                {
                    case 'steps':
                        //Set
                        title = 'Steps & Hazards';
                        break;
                    case 'employees':
                        //Set
                        title = 'Employees ('+this.empCount+')';
                        icon = 'group';
                        break;
                }

                //Send it
                return '<i class="fa fa-'+icon+'"></i> ' + title;
            }
        },

        methods: {

            cloneJSA(){
                //Confirm it
                if(!confirm('Are you sure you want to clone this JSA?'))
                {
                    return;
                }

                //Send it
                this.cloning = true;

                //Send it
                this.$http
                    .post('jsa/clone/' + this.jsa_id)
                    .then(response => {
                        //Return to main list?
                        this.$router.push('/jsa/edit/' + response.data.jsa_id);
                    })
                    .catch(response => {

                    })
                    .then(response => {
                        //Rest
                        this.cloning = false;
                    });
            },

            getRacLevelColor(level){
                //switch
                switch(level)
                {
                    case 'Extremely High':
                        return 'danger';
                        break;
                    case 'High':
                        return 'orange';
                        break;
                    case 'Medium':
                        return 'warning';
                        break;
                    case 'Low':
                        return 'success';
                        break;

                }

                return 'success';
            },

            getJsa: function() {
                //Get the data
                this.$http
                    .get('jsa/view/' + this.jsa_id)
                    .then(response => {
                        //Set all the data
                        this.jsa = response.data.jsa;
                        this.files = response.data.files;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveNewFile(){
                //Helper
                this.uploading = true;

                //Send it
                this.$http
                    .postWithSingleFile('/files/upload', {asset_type: 'Jsa', asset_id: this.jsa.jsa_id}, this.new_file)
                    .then(response => {
                        //Update the files?
                        this.files.push(response.data);

                        //Alert the user
                        this.$toastr.success('File Uploaded');

                        //Reset
                        this.new_file = null;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Reset
                        this.uploading = false;
                    });
            },

            jsaEmpSelect(employee){
                if (employee == null)
                {
                    return;
                }

                //Send it
                this.new_employees.push(employee);

                //Reset
                this.$refs.jsaEmpSelector.clearInput();
            },

            handleHide(bvEvt) {
                //debugging
                if(this.$root.debug)
                {
                    //console.log('Hiding Modal');
                }
            },

            handleHidden(bvEvt) {
                //Reset the values
                this.errors = {};
                this.new_employees = [];
            },

            handleOk(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Show loading?

               //Do it
               this.addEmployees();
            },

            addEmployees() {
                //Reset the errors
                this.errors = {};

                //Build the List
                var employeeIds = [];

                //Loop
                for (var i = this.new_employees.length - 1; i >= 0; i--)
                {
                    employeeIds.push(this.new_employees[i].EmployeeId);
                }

                //Send it
                this.$http
                .post('/jsa/employees/'+this.jsa.jsa_id, {'employee_ids': employeeIds})
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Employees Added');

                    //Close the modal
                    this.modal_open = false;

                    //Refresh
                    this.$refs.jsaEmpList.refresh();

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                });
            },
        },
        mounted() {
            //Get the JSA
            this.getJsa();

            //Check for a hash
            if(window.location.hash)
            {
                //Set the current tab
                this.curTab = window.location.hash.replace('#', '');
            }
        }
    }
</script>
<style>
    .badge-orange {
        background-color: #ef871d;
        color: #fff;
    }
</style>
